import {post} from 'aws-amplify/api';
import {Command, type PostMethod} from '../../Command';

export class ValidateEmailUserCommand extends Command<PostMethod> {
  constructor() {
    super(post, {
      path: '/me/validateemail',
    });
  }

  async deserialize(output: ReturnType<typeof post>): Promise<void> {
    await output.response;
  }
}
